import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { ThemeProvider } from './context/ThemeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// The width of the thin scrollbar in this browser, as --sbw: the menu frame above a scrolling list keeps this much free on its
// right, so the list's cards and the menu frame end at the same line (the list reserves that space for its scrollbar).
try {
  const probe = document.createElement('div');
  probe.style.cssText = 'position:absolute;top:-999px;width:100px;height:50px;overflow-y:scroll;scrollbar-width:thin;visibility:hidden';
  document.body.appendChild(probe);
  document.documentElement.style.setProperty('--sbw', `${probe.offsetWidth - probe.clientWidth}px`);
  document.body.removeChild(probe);
} catch { /* the css falls back to a fixed width */ }
// No black browser tooltips anywhere (organisation, tenant and customer portal): a title attribute is taken off as the mouse reaches the
// element, before the browser can show it. The text is kept in data-title (nothing else reads it), and aria-labels are left alone.
document.addEventListener('mouseover', (e) => {
  const el = e.target instanceof Element ? e.target.closest('[title]') : null;
  if (el) { el.setAttribute('data-title', el.getAttribute('title')); el.removeAttribute('title'); }
}, true);
document.addEventListener('focusin', (e) => {
  const el = e.target instanceof Element ? e.target.closest('[title]') : null;
  if (el) { el.setAttribute('data-title', el.getAttribute('title')); el.removeAttribute('title'); }
}, true);
